import { TTeudotList } from '../../../../../../models/RequestsModel/teudot';

export const filterTeudot = (list: TTeudotList, input: string): TTeudotList =>
    list.filter(
        (item) =>
            item.Delivery_Num.toString().includes(input) ||
            item.Customer_Name.toLocaleLowerCase().includes(input.toLocaleLowerCase()),
    );
